import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiDetailResponse, ApiPaginatedResponse, PaginateResult } from '../interface/data.interface';
import { AccessExcelUploadedAmplitude, Invitations, InvitationsImportResult } from '../interface/invitation.interface';
import { CreateFastPassAccessDTO } from '../macro-community/interfaces/fastpass-access.interface';
import { DataService } from './data.service';
import { UserService } from './user.service';
import { AmplitudeService } from './amplitude.service';
import { AmplitudeEvent } from '../interface/amplitude.interface';

@Injectable()
export class InvitationService extends DataService {
  headers: HttpHeaders;

  constructor(private http: HttpClient, protected injector: Injector, protected store: Store<any>, private userService: UserService, private amplitudeService: AmplitudeService) {
    super(injector, store);
    let building = this.userService.getBuilding();
    this.headers = new HttpHeaders({
      authorization: JSON.parse(localStorage.getItem('currentUser')).token,
      'fb-token': JSON.parse(localStorage.getItem('currentUser')).fbToken,
    });
    if (building) this.headers.append('buildingId', building.id);
  }

  fetchInvitations(page, limit, search, find?) {
    const params = search ? `&${search}` : '';
    find = find ? `&search=${find}` : '';
    return this.http
      .get(`${environment.apiUrl}/invitation?page=${page}&rowsPerPage=${limit}${params}${find}`)
      .toPromise()
      .then((res) => {
        return res || [];
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  getInvitations(params: any) {
    let parameters = new HttpParams();
    !params.typeVisit ? null : parameters = parameters.set("type", params.typeVisit);
    !params.unit ? null : parameters = parameters.set("unit", params.unit);
    !params.startDate ? null : parameters = parameters.set("startDate", params.startDate);
    !params.endDate ? null : parameters = parameters.set("endDate", params.endDate);
    !params.search ? null : parameters = parameters.set("search", params.search);
    parameters = parameters.set("page", params.page);
    parameters = parameters.set("size", params.size);
    return this.http.get(`${environment.apiUrl}/admin/v1/invitations`, { params: parameters });
  }

  getGroupStatusInvitations() {
    return this.http.get(`${environment.apiUrl}/admin/v1/invitations/graphic`);
  }

  fetchInvitationsParams(params: string) {
    return this.http
      .get(`${environment.apiUrl}/admin/v1/invitations?${params}`)
      .toPromise()
      .then((res) => {
        return res || [];
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  }

  storeInvitation(invitation) {
    return this.http
      .post(`${environment.apiUrl}/invitation`, invitation)
      .toPromise()
      .then((res: any) => {
        return res || [];
      })
      .catch((err) => {
        console.log('errr: ', err);
        return Promise.reject(err);
      });
  }

  updateStatus(id, data) {
    return this.http
      .put(`${environment.apiUrl}/invitation/${id}/update-status`, data)
      .toPromise()
      .then((res: any) => {
        return res || [];
      })
      .catch((err) => {
        console.log('errr: ', err);
        return Promise.reject(err);
      });
  }

  exportVisitantsHistory(formValue) {
    let params = new HttpParams()
      .append("endDate", formValue.endDate)
      .append("startDate", formValue.startDate)

    formValue.unit ? params = params.set("unit", formValue.unit) : null;
    formValue.search ? params = params.set("search", formValue.search) : null
    formValue.type ? params = params.set("type", formValue.type) : null
    formValue.format ? params = params.set("format", formValue.format) : null

    if (formValue.insideBuilding == true || formValue.insideBuilding == false) params = params.set("insideBuilding", formValue.insideBuilding);

    return this.http.get(`${environment.apiUrl}/admin/v1/invitations/download`, { params })
  }

  generateFilePdfOrExcel(buidingId: string, params: HttpParams) {
    return this.http.get(`${environment.apiUrl}/super/v1/invitations/${buidingId}/download`, { params })
  }

  getInvitationsForMacroAdmin(params: HttpParams, buildingId: string): Observable<PaginateResult<any>> {
    let parameters = new HttpParams();

    parameters = parameters.set("page", params.get('page'));
    parameters = parameters.set("size", params.get('size'));
    if (params.has('startDate')) parameters = parameters.set("startDate", params.get('startDate'));
    if (params.has('endDate')) parameters = parameters.set("endDate", params.get('endDate'));
    if (params.has('unit')) parameters = parameters.set("unitId", params.get('unit'));
    if (params.has('status')) parameters = parameters.set("status", params.get('status'));
    if (params.has('type')) parameters = parameters.set("type", params.get('type'));
    if (params.has('buildingId')) parameters = parameters.set("buildingId", params.get('buildingId'));
    if (params.has('search')) parameters = parameters.set("search", params.get('search'));
    if (params.has('buildingId')) parameters = parameters.set("buildingId", params.get('buildingId'));
    if (!this.headers.get('macroBuildingId')) this.headers = this.headers.set('macroBuildingId', buildingId);
    return this.http.get(`${environment.apiUrl}/admin-macro/v1/invitations`, { params: parameters, headers: this.headers }) as Observable<PaginateResult<any>>;
  }

  exportInvitationsForMacroAdmin(buildingId: string, params: HttpParams) {
    let parameters = new HttpParams();
    parameters = parameters.set("page", params.get('page'));
    parameters = parameters.set("size", params.get('size'));
    if (params.has('startDate')) parameters = parameters.set("startDate", params.get('startDate'));
    if (params.has('endDate')) parameters = parameters.set("endDate", params.get('endDate'));
    if (params.has('unit')) parameters = parameters.set("unitId", params.get('unit'));
    if (params.has('status')) parameters = parameters.set("status", params.get('status'));
    if (params.has('type')) parameters = parameters.set("type", params.get('type'));
    if (params.has('buildingId')) parameters = parameters.set("buildingId", params.get('buildingId'));
    if (params.has('search')) parameters = parameters.set("search", params.get('search'));
    if (params.has('buildingId')) parameters = parameters.set("buildingId", params.get('buildingId'));
    if (params.has('format')) parameters = parameters.set("format", params.get('format'));
    if (params.has('insideBuilding')) parameters = parameters.set("insideBuilding", params.get('insideBuilding'));

    if (!this.headers.get('macroBuildingId')) this.headers = this.headers.set('macroBuildingId', buildingId);

    return this.http.get(`${environment.apiUrl}/admin-macro/v1/invitations/download`, { params, headers: this.headers })
  }

  createFastPassAccess(access: CreateFastPassAccessDTO) {
    return this.http.post(`${environment.newApiBackend}/api/invitation/invitation-management`, access, { headers: this.headers });
  }

  getPaginationInvitations(params: HttpParams) {
    const unitId = this.getProprietorUnitId();
    const p = unitId ? params.set('unitId', unitId) : params;
    return this.http.get<ApiPaginatedResponse<Invitations>>(`${environment.newApiBackend}/api/invitation/invitation-management/list`, { params: p });
  }

  getInvitationManagement(id: string) {
    return this.http.get<ApiDetailResponse<Invitations>>(`${environment.newApiBackend}/api/invitation/invitation-management/${id}`);
  }

  deleteInvitation(id: string) {
    return this.http.delete(`${environment.newApiBackend}/api/invitation/invitation-management/${id}`);
  }

  uploadBulkInvitations(file: File, buildingId: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('buildingId', buildingId);
    return this.http.post<ApiDetailResponse<InvitationsImportResult>>(`${environment.newApiBackend}/api/invitation/invitation-management/bulk-upload`, formData, { headers: this.headers });
  }

  eventAmplitudeDownloadAccessExcel() {
    this.amplitudeService.sendToAmplitude({
      event_type: AmplitudeEvent.accessExcelDownloaded,
      user_id: this.userService.getUser().id,
    });
  }

  eventAmplitudeUploadAccessExcel(data: AccessExcelUploadedAmplitude) {
    this.amplitudeService.sendToAmplitude({
      event_type: AmplitudeEvent.accessExcelUploaded,
      user_id: this.userService.getUser().id,
      event_properties: {
        'Status File': data.statusFile,
        'Massive access created': data.massiveAccessCreated,
        'Failed entries': data.failedEntries,
      },
    });
  }
}
